/**
 * Live leave ends that booking. Another talk needs a new booking.
 */

export const LEFT_REASON = 'left';

/**
 * @param {Object} [tx]
 * @returns {boolean}
 */
export const transactionWasLeft = tx =>
  tx?.attributes?.protectedData?.sessionLeft === true ||
  tx?.attributes?.protectedData?.sessionEndedReason === LEFT_REASON;
